import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFormDetail } from "../../../../../redux/slice/form";
import { useHookForm } from "../../../../../components/hooks";

import {
  FormCheckbox,
  FormInputtextarea,
} from "../../../../../components/formElement";
import { option_control_type } from "../../../../../service/option";

import ImgQuestion from "../../../../../images/other/question_icon.PNG";

import { Button } from "primereact/button";

export default function ModuleControlStep2(props) {
  const { setActiveIndex, onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  // 表單欄位預設值
  const defaultValues = {
    a1: [],
    a2: "",
    a3: "",
  };
  const { handleSubmit, getValues, reset, yup, setSchema, setting } =
    useHookForm({
      defaultValues,
    });
  const tbData = [
    {
      key: 1,
      type: (
        <div className="font-bold">
          近視控制
          <br />
          治療選擇
        </div>
      ),
      liquid: <span className="font-bold">學童近視控制專用日拋</span>,
      daily: <span className="font-bold">角膜塑型片</span>,
      shaping: <span className="font-bold">近視控制框架鏡片</span>,
      glass: <span className="font-bold">多焦點眼鏡</span>,
    },
    {
      key: 2,
      type: <span className="font-bold">效果</span>,
      liquid: (
        <span className="font-bold border-bottom-1">
          可降低近視進展風險52%-59%
        </span>
      ),
      daily: (
        <span className="font-bold border-bottom-1">
          可降低近視進展風險35%至55%
        </span>
      ),
      shaping: (
        <span className="font-bold border-bottom-1">
          可降低近視進展風險52%-62%
        </span>
      ),
      glass: <span className="font-bold border-bottom-1">無提及</span>,
    },
    {
      key: 3,
      type: <span className="font-bold">☺ 優點</span>,
      liquid: (
        <ul className="pl-4 m-0">
          <li>每日拋棄；安全方便</li>
          <li>無須搓洗；出遊不用帶藥水</li>
          <li>運動安全；戶外活動意願高</li>
          <li>視力穩定；全天保持清晰</li>
          <li>異物感低，單日遺失費用低</li>
        </ul>
      ),
      daily: (
        <ul className="pl-4 m-0">
          <li>白天不須戴眼鏡</li>
          <li>運動安全；戶外活動意願更高</li>
        </ul>
      ),
      shaping: (
        <ul className="pl-4 m-0">
          <li>無侵入性；不接觸眼睛</li>
          <li>可選擇眼鏡造型</li>
        </ul>
      ),
      glass: (
        <ul className="pl-4 m-0">
          <li>無侵入性；不接觸眼睛</li>
          <li>可選擇眼鏡造型</li>
        </ul>
      ),
    },
    {
      key: 4,
      type: <span className="font-bold">☹ 缺點</span>,
      liquid: (
        <ul className="pl-4 m-0">
          <li>白天至少要配戴10小時以上</li>
          <li>取下隱形眼鏡後,須搭配眼鏡矯正</li>
          <li>一周須戴6天</li>
          <li>{`度數>650度與散光>75度不合適(未來可能有最高近視1000度的產品)`}</li>
        </ul>
      ),
      daily: (
        <ul className="pl-4 m-0">
          <li>需家長監督清潔鏡片</li>
          <li>晚上至少要睡眠6小時以上</li>
          <li className="font-bold">
            (若療程期間真不足6小時仍建議要配戴，時數少仍有維持形狀的效果)
          </li>
          <li>晚上視力不穩定、異物感</li>
          <li>有破損、遺失風險及費用</li>
        </ul>
      ),
      shaping: (
        <ul className="pl-4 m-0">
          <li>運動時需注意安全</li>
          <li>需要孩童配戴意願高</li>
          <li>配戴時間少影響效果</li>
          <li>外觀可能受影響</li>
        </ul>
      ),
      glass: (
        <ul className="pl-4 m-0">
          <li>運動時需注意安全</li>
          <li>需要孩童配戴意願高</li>
          <li>配戴時間少影響效果</li>
          <li>外觀可能受影響</li>
        </ul>
      ),
    },
    {
      key: 5,
      type: <span className="font-bold">適合族群</span>,
      liquid: (
        <ul className="pl-4 m-0">
          <li>忙碌的家長</li>
          <li>不想清潔鏡片</li>
          <li>重視睡眠品質、發育</li>
          <li>
            睡眠較少的國高中生
            <span className="font-bold">(須留意睡眠過少可能眼睛會較乾)</span>
          </li>
          <li>喜愛運動、戶外活動</li>
          <li>在意外表的孩童</li>
        </ul>
      ),
      daily: (
        <ul className="pl-4 m-0">
          <li>喜愛運動、戶外活動</li>
          <li>白天不想戴眼鏡、隱形眼鏡</li>
          <li>睡眠時間充足</li>
          <li>能夠定期回診</li>
          <li>在意外表的孩童</li>
          <li className="font-bold">若有不適，能及時處置的家長及小孩</li>
        </ul>
      ),
      shaping: (
        <ul className="pl-4 m-0">
          <li>不想接觸眼睛</li>
          <li>喜歡配戴眼鏡</li>
        </ul>
      ),
      glass: (
        <ul className="pl-4 m-0">
          <li>不想接觸眼睛</li>
          <li>喜歡配戴眼鏡</li>
          <li>輔助使用較高濃度長效散瞳劑不同焦距</li>
        </ul>
      ),
    },
    {
      key: 6,
      type: <span className="font-bold">預估費用</span>,
      liquid: <span className="font-bold">每年大約3萬元初頭。</span>,
      daily: (
        <span className="font-bold">
          依據廠牌、設計不同，每副約3萬到5萬，高度數片、散光片或智能驗配鏡片則通常價位較高。
        </span>
      ),
      shaping: (
        <span className="font-bold">
          依據廠牌、設計不同，每副3萬元 ~
          3萬多元不等（有一般片、抗藍光片、偏光片、變色片等片種）
        </span>
      ),
      glass: (
        <span className="font-bold">
          依據廠牌、設計不同，價位在數千至數萬元不等
        </span>
      ),
    },
  ];

  useEffect(() => {
    setSchema(
      yup
        .object({
          a1: yup
            .array()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return value.length > 0;
              }
            ),
          a2: yup
            .string()
            .test(
              "isValidPass",
              "必填",
              (value, { from: [{ value: data }] }) => {
                return data.a1.indexOf(8) === -1 || value;
              }
            ),
          a3: yup.string().required("必填"),
        })
        .required()
    );
  }, []);

  useEffect(() => {
    if (redux_form.formDetail?.step2) {
      reset(redux_form.formDetail.step2);
    }
  }, [redux_form]);

  const onSubmit = (submitData) => {
    let jsonData = {
      ...redux_form.formDetail,
      step2: submitData,
    };
    dispatch(setFormDetail(jsonData));

    onTabChange({ index: 2 });
  };

  return (
    <>
      <div className="flex align-items-center mb-2">
        <span className="text-2xl font-bold">選項比較</span>
        <span className="flex-auto"></span>
        <span
          className="hover:text-gray-600 border-bottom-1 cursor-pointer"
          onClick={() => setActiveIndex(6)}
        >
          參考文獻
        </span>
      </div>
      <div className="overflow-x-auto">
        <table
          className="md:w-full table-layout-fixed table-collapse"
          style={{ width: "60rem" }}
        >
          <tbody>
            {tbData.map((item, index) => (
              <tr
                key={item.key}
                style={{
                  backgroundColor:
                    index === 0
                      ? "#ff9966"
                      : index % 2 === 1
                      ? "#fbe5d6"
                      : "#d8e9cd",
                }}
              >
                <td className="w-6rem border-1 border-500 p-1">{item.type}</td>
                <td className="border-1 border-500 p-1">{item.liquid}</td>
                <td className="border-1 border-500 p-1">{item.daily}</td>
                <td className="border-1 border-500 p-1">{item.shaping}</td>
                <td className="border-1 border-500 p-1">{item.glass}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="text-lg mt-4">
        <div className="flex align-items-center text-2xl font-bold mb-1">
          <img className="mr-2" src={ImgQuestion} alt="Question" />
          您目前比較想要選擇的方式是? (複選)
        </div>
        <div className="flex flex-column ml-2">
          {option_control_type.map((item) => (
            <FormCheckbox
              key={`control_type_${item.value}`}
              className="white-space-prewrap m-0"
              setting={setting}
              data={{
                name: "a1",
                label: item.label,
                type: "multi",
                value: item.value,
                isWrap: true,
              }}
            />
          ))}
        </div>
        {getValues("a1").indexOf(8) !== -1 && (
          <FormInputtextarea
            className="w-full md:w-8"
            setting={setting}
            data={{
              name: "a2",
            }}
          />
        )}

        <div className="text-2xl font-bold mt-3 mb-1">
          對於以上眼鏡訊息，我想要再瞭解更多，我的問題有：
        </div>
        <FormInputtextarea
          className="w-full md:w-8"
          setting={setting}
          data={{
            name: "a3",
            placeholder: "若無請填寫『無』",
          }}
        />

        <div className="col-12 text-center my-3">
          <Button
            className="p-button-warning text-white px-3 rotate-icon-x-180"
            type="button"
            label="上一步：前言"
            icon="fa fa-reply bg-main border-round-md p-1"
            onClick={() => onTabChange({ index: 0 })}
          />
          <Button
            className="p-button-warning text-white ml-3 px-3 rotate-icon-xy-180 rotate-icon-y-180"
            type="submit"
            label="下一步：考量"
            icon="fa fa-reply bg-main border-round-md p-1"
          />
        </div>
      </form>
    </>
  );
}
